// 获取cookie
function getCookie(name) {
    const arr = document.cookie.split("; ");
    for (let i = 0; i < arr.length; i++) {
        const arr2 = arr[i].split("=");
        if (arr2[0] == name) {
            return arr2[1];
        }
    }
    return "";
}

// 是否登录
function checkLogin() {
    if (getCookie("GCLOUD_ID") === "" || getCookie("GCLOUD_SESSIONKEY") === "") {
        return false;
    }
    return true;
}

// 获取url的query值
function getQuery(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

// 获取域名
function getDomain() {
    const { hostname } = window.location;
    const hostArr = hostname.split(".");

    return `.${hostArr.slice(-2).join(".")}`;
}

function clearCookie(key) {
    if (key) {
        document.cookie = `${key}=0;expires=${new Date(0)};Domain=${getDomain()};path=/`;
    }
}

// 跳转登录
function jumpLogin(url) {
    let loginUrl = "";

    if (getCookie("i18next") === "en-GB") {
        loginUrl = `http://email.gcloud.tencent.com/mail/login?backurl=${encodeURIComponent(url)}`;
    } else {
        loginUrl = `http://web.gcloud.qq.com/qqlogin?backurl=${encodeURIComponent(url)}`;
    }

    window.location.href = loginUrl;
}

export const LANG_EN = "en-GB";
export const LANG_CN = "zh-CN";

export { getCookie, checkLogin, getQuery, getDomain, clearCookie, jumpLogin };
